<input
  style="display: none"
  [ngxMatTimepicker]="picker"
  [format]="24"
  readonly
/>
<ngx-mat-timepicker
  #picker
  [format]="24"
  [defaultTime]="defaultTime"
  (timeSet)="setTime($event)"
  [cancelBtnTmpl]="cancelButton"
  [confirmBtnTmpl]="confirmButton"
></ngx-mat-timepicker>

<ng-template #cancelButton>
  <app-button
    buttonType="secondary"
    [isBtnSmall]="true"
    [text]="'global.cancel' | transloco"
  ></app-button>
</ng-template>

<ng-template #confirmButton>
  <app-button
    [isBtnSmall]="true"
    [text]="'global.save' | transloco"
  ></app-button>
</ng-template>
